<template lang="pug">
  v-dialog(v-model='dialogImporEspe' scrollable max-width='80%' persistent content-class="flex xs12 sm6 md6")
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Importar Productos
      v-card-text
        v-row(dense)
          v-flex(xs12='xs12')
            template
              v-stepper(v-model='e6')
                v-stepper-header
                  v-stepper-step( :complete="e6 > 1" step="1") Marca
                  v-divider
                  v-stepper-step(step="2") Categoria
                v-stepper-items
                  v-stepper-content(step='1')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          h2(style="color: black; font-size: 80%") En caso de no poseer marcas en el sistema, agregue un documento excel:
                          p
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              v-flex(xs12 sm12 md12 style='display: flex; justify-content: center;')
                                a(href='javascript:;' class="button_s my_file el-button.button_s el-button--primary")
                                  input(type="file" class="my_input" @change="importExcelMarca" id="uploadMarca")
                                  | Marcas
                            v-col(cols='12' sm='12' md='12')
                              v-data-table.elevation-1(:headers='tableHeadersMarca' :search='searchMarca' item-key='arrayExcelMarca' :items='arrayExcelMarca')
                                template(v-slot:top)
                                  v-toolbar(flat color='primary' dark)
                                    v-toolbar-title.justify-center Marcas
                                    v-divider.mx-4(inset vertical)
                                    v-spacer
                                    v-text-field.text-xs-center(v-model='searchMarca', label='Búsqueda', single-line, hide-details, color='success')
                                    v-spacer
                                    v-icon(v-if='mostrarMarca' color='primary') mdi-check-circle-outline
                                    v-btn(color='success' width='22%' small dark @click='saveMarca')
                                      v-icon(small) mdi-microsoft-excel 
                                      | Guardar
                                template(v-slot:no-data='')
                                  h1 Inserte un documento Excel
                    v-btn(color='success' dark @click='validarSteps()')
                      span Continuar
                  v-stepper-content(step='2')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          h2(style="color: black; font-size: 80%") En caso de no poseer categorias en el sistema, agregue un documento excel:
                          p
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              v-flex(xs12 sm12 md12 style='display: flex; justify-content: center;')
                                a(href='javascript:;' class="button_s my_file el-button.button_s el-button--primary")
                                  input(type="file" class="my_input" @change="importExcelLinea" id="uploadLinea")
                                  | Categorias
                            v-col(cols='12' sm='12' md='12')
                              v-data-table.elevation-1(:headers='tableHeadersLinea' :search='searchLinea' item-key='arrayExcelMarca' :items='arrayExcelLinea')
                                template(v-slot:top)
                                  v-toolbar(flat color='primary' dark)
                                    v-toolbar-title.justify-center Categorias
                                    v-divider.mx-4(inset vertical)
                                    v-spacer
                                    v-text-field.text-xs-center(v-model='searchLinea', label='Búsqueda', single-line, hide-details, color='success')
                                    v-spacer
                                    v-icon(v-if='mostrarLinea' color='primary') mdi-check-circle-outline
                                    v-btn(color='success'  width='22%' small dark @click='saveLinea')
                                      v-icon(small) mdi-microsoft-excel
                                      | Guardar
                                template(v-slot:no-data='')
                                  h1 Inserte un documento Excel
                                
                    v-btn(color='error' dark @click='e6 = 1' class="mr-5") Atras
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Salir
</template>

<script>
import Api from '@/services/methods'
import xlsx from "xlsx"
export default {
  props: ['dialogImporEspe'],
  name: 'ImportarEspe',
  data: () => ({
    e6: 1,
    searchMarca: '',
    searchLinea: '',
    // marca
    arrayExcelMarca: [],
    // headersMarca: [],
    tableHeadersMarca: [
      { text: 'codMarca', value: 'codMarca', align: 'center' },
      { text: 'nombre', value: 'nombre', align: 'center' }
    ],
    marca: [],
    mostrarMarca: false,
    // linea
    arrayExcelLinea: [],
    // headersLinea: [],
    tableHeadersLinea: [
      { text: 'codLinea', value: 'codLinea', align: 'center' },
      { text: 'descripcion', value: 'descripcion', align: 'center' }
    ],
    linea: [],
    mostrarLinea: false
  }),

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarMarcas()
       this.listarLineas()
    },

    listarMarcas () {
      Api.get('marca')
        .then(response => {
          this.marca = response.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarLineas () {
      Api.get('linea')
        .then(response => {
          this.linea = response.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    validarSteps () {
      switch (this.e6) {
        case 1:
          this.e6 = 2
          break
      }
    },

    close () {
      setTimeout(() => {
        // this.tableHeadersMarca = []
        this.arrayExcelMarca = []
        this.mostrarMarca = false

        // this.tableHeadersLinea = [] 
        this.arrayExcelLinea = []
        this.mostrarLinea = false
      }, 300)
      this.$emit('close')
    },

    importExcelMarca(e) {
      // this.tableHeadersMarca = []
      this.arrayExcelMarca = []
      this.mostrarMarca = false
      const files = e.target.files
      if (!files.length) {
        return
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$swal({
          icon: 'error',
          title: 'Formato incorrecto',
          text: 'Por favor, verifique el documento e intente de nuevo'
        })
      }
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          const XLSX = xlsx
          const workbook = XLSX.read(data, {
            type: "binary"
          })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
          for (var i = 0; i < ws.length; i++) {
            this.arrayExcelMarca.push(ws[i])
          }
          const a = workbook.Sheets[workbook.SheetNames[0]];
          // this.headersMarca = this.getHeader(a);

          console.log('Marcas')
          console.log(this.arrayExcelMarca)
            
            /* for (let i = 0; i < this.headersMarca.length; i++) {
              this.tableHeadersMarca.push({
                text: this.headersMarca[i],
                value: this.headersMarca[i]
              })
            } */

        } catch (e) {
          return alert("Read failure!")
        }
      };
      fileReader.readAsBinaryString(files[0])
      var input = document.getElementById("uploadMarca")
      input.value = ""
    },

    importExcelLinea(e) {
      // this.tableHeadersLinea = []
      this.arrayExcelLinea = []
      this.mostrarLinea = false
      const files = e.target.files
      if (!files.length) {
        return
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$swal({
          icon: 'error',
          title: 'Formato incorrecto',
          text: 'Por favor, verifique el documento e intente de nuevo'
        })
      }
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          const XLSX = xlsx
          const workbook = XLSX.read(data, {
            type: "binary"
          })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
          for (var i = 0; i < ws.length; i++) {
            this.arrayExcelLinea.push(ws[i])
          }
          const a = workbook.Sheets[workbook.SheetNames[0]];
          // this.headersLinea = this.getHeader(a);

          console.log('linea')
          console.log(this.arrayExcelLinea)
            
            /* for (let i = 0; i < this.headersLinea.length; i++) {
              this.tableHeadersLinea.push({
                text: this.headersLinea[i],
                value: this.headersLinea[i]
              })
            } */

        } catch (e) {
          return alert("Read failure!")
        }
      };
      fileReader.readAsBinaryString(files[0])
      var input = document.getElementById("uploadLinea")
      input.value = ""
    },

    getHeader(sheet) {
      const XLSX = xlsx;
      const encabezado = [];
      const rango = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = rango.s.r;
      let i = 0;
      for (C = rango.s.c; C <= rango.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ];
        var hdr = "UNKNOWN" + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = 'FORMATO INCORRECTO';
          }else {
            hdr = 'FORMATO INCORRECTO' + i;
          }
          i++;
        }
        encabezado.push(hdr);
      }
      return encabezado;
    },

    validarExcelMarca () {
      if (/* this.tableHeadersMarca.length === 0 || !this.tableHeadersMarca || */ this.arrayExcelMarca.length === 0 || !this.arrayExcelMarca) {
        this.$swal({
          icon: 'error',
          title: 'Data incompleta',
          text: 'Por favor cargue un documento Excel'
        })
        return true
      }
      return false
    },

    validarExcelLinea () {
      if (/* this.tableHeadersLinea.length === 0 || !this.tableHeadersLinea || */ this.arrayExcelLinea.length === 0 || !this.arrayExcelLinea) {
        this.$swal({
          icon: 'error',
          title: 'Data incompleta',
          text: 'Por favor cargue un documento Excel'
        })
        return true
      }
      return false
    },

    saveMarca () {
      if (!this.validarExcelMarca()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })
        Api.post('marca/cargarExcelMarca', this.arrayExcelMarca)
            .then(response => {
              if (response.data.status === 'denied') {
                this.$swal({
                  icon: 'error',
                  title: 'Datos ya existentes!',
                  text: response.data.message
                })
              } else {
                this.$swal({
                  icon: 'success',
                  title: 'Inclusion exitosa',
                  text: 'Todos los datos han sido guardados'
                })
                this.marca.push(response.data)
                this.listarMarcas()
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
            this.mostrarMarca = true
            // this.tableHeadersMarca = []
            this.arrayExcelMarca = []
      }
    },

    saveLinea () {
      if (!this.validarExcelLinea()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })
        Api.post('linea/cargarExcelLinea', this.arrayExcelLinea)
            .then(response => {
              if (response.data.status === 'denied') {
                this.$swal({
                  icon: 'error',
                  title: 'Datos ya existentes!',
                  text: response.data.message
                })
              } else {
                this.$swal({
                  icon: 'success',
                  title: 'Inclusion exitosa',
                  text: 'Se han cargado las especificaciones del producto correctamente'
                })
                this.linea.push(response.data)
                this.listarLineas()
                this.close()
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
            this.mostrarLinea = true
            // this.tableHeadersLinea = []
            this.arrayExcelLinea = []
      }
    }

  }
}
</script>

<style lang="scss">

.button_s {
  width: 78px;
  margin: 5px 10px 5px 5px;
}
.button_m {
  width: 100px;
  margin: 5px 10px 5px 5px;
}
.my_file {
  position: relative;
  .my_input {
    position: absolute;
    opacity: 0;
    width: 78px;
    height: 30px;
    top: 0;
    left: 0;
  }
}
.tabla {
  width: 100%;
  .header {
    width: 100%;
    height: 46px;
    background: whitesmoke;
    display: flex;
    flex-direction: row;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  .item {
    background: white;
    width: 100%;
    }
}

</style>
